// Media queries the shared kit needs beside brand's (brand designSystem/media.js
// fills first; `deepDefaults` adds only a MISSING key).
//
// `forcedColors` — Windows Contrast themes (and every forced-colours mode): the
// browser repaints fills with system colours and drops every box-shadow, so a
// selection shown by a fill or an elevation vanishes and a focus ring drawn as
// a shadow is gone. A component answers with a system-colour OUTLINE:
// `'@forcedColors': { … }` (AppSegmentedItem is the first; 2026-09-30).
export default {
  forcedColors: '(forced-colors: active)'
}
